module.exports = __webpack_public_path__ + "img/treatments-directory-dashboard-mobile-ru.d9b9f85a.jpg";